const getCreatePlaybookRoute = ({
  templateId,
  profileId,
  authUserId,
  isIndividualPlaybook,
}: {
  templateId: string | undefined
  profileId: string | undefined
  authUserId: string | undefined
  isIndividualPlaybook: boolean
}) => {
  if (!templateId || !profileId) {
    return '/app/playbook-builder'
  }

  let baseRoute = `/api/create-playbook/${profileId}?templateId=${templateId}`

  if (!isIndividualPlaybook) {
    baseRoute += `&authUserId=${authUserId}`
  }

  return baseRoute
}

export { getCreatePlaybookRoute }
